function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_255",
  "data-name": "Trazado 255",
  d: "M0,0H27V27H0Z",
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_256",
  "data-name": "Trazado 256",
  d: "M6.259,22a2.457,2.457,0,0,0,2.518,2.375H18.848A2.457,2.457,0,0,0,21.366,22V10.125A2.457,2.457,0,0,0,18.848,7.75H8.777a2.457,2.457,0,0,0-2.518,2.375ZM21.366,4.188H18.219l-.894-.843A1.31,1.31,0,0,0,16.444,3H11.181a1.31,1.31,0,0,0-.881.344l-.894.843H6.259A1.228,1.228,0,0,0,5,5.375,1.228,1.228,0,0,0,6.259,6.563H21.366a1.228,1.228,0,0,0,1.259-1.188A1.228,1.228,0,0,0,21.366,4.188Z",
  transform: "translate(-0.312 -0.188)",
  fill: "#050358"
});

var SvgDelete24Px = function SvgDelete24Px(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "delete-24px",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDelete24Px, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete-24px.ee15ed8c.svg";
export { ForwardRef as ReactComponent };